import { render, staticRenderFns } from "./ListaAttivitaV.vue?vue&type=template&id=60744207&"
import script from "./ListaAttivitaV.vue?vue&type=script&lang=js&"
export * from "./ListaAttivitaV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports